import React, { Component } from "react";
import { API_TOKEN_NAME, IMAGE_URL } from "../../constants";
import { Route } from "react-router-dom";
import { scAxiosAdmin } from "../..";
import Header from "../../component/frontend/Header";
import Footer from "../../component/frontend/Footer";
import banner_img from "../../images/banner-profile.jpg";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";

const getSinglePackage = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/packages/getsinglepackagedata/" + id, {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getVideo = () => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/settings/30", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
class SinglePackage extends Component {
  state = {
    package_name: "",
    package_age: "",
    package_gender: "",
    package_pre_condition: "",
    package_department: "",
    package_pic: "",
    package_desc: "",
    package_banner_image: "",
    dynamic_video: "",
  };
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  refreshgetSinglePackage = () => {
    let package_name_string = this.props.match.params.name;
    let new_package_name = package_name_string.replaceAll("-", " ");
    getSinglePackage(package_name_string)
      .then((res) => {
        if (res.status === true) {
          var records = res.data;

          this.setState({
            package_name: records.name,
            package_age: records.age,
            package_gender: records.gender,
            package_type: records.package_type,
            package_nature: records.package_nature,
            ipd_amount: records.ipd_amount,
            opd_amount: records.opd_amount,
            package_pre_condition: records.pre_existing_conditon_id,
            package_department: records.department_name,
            package_desc: records.description,
            package_pic: records.image,
            package_banner_image: records.banner_image,
          });
        } else {
          this.setState({
            package_name: "",
            package_age: "",
            package_gender: "",
            package_pre_condition: "",
            package_department: "",
            package_desc: "",
            package_pic: "",
            package_banner_image: "",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  refreshgetVideo = () => {
    getVideo()
      .then((res) => {
        if (res) {
          var records = res;
          this.setState({
            dynamic_video: records.value,
          });
        } else {
          this.setState({
            dynamic_video: "",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  componentDidMount() {
    this.refreshgetSinglePackage();
    this.refreshgetVideo();
  }
  render() {
    return (
      <div>
        <SEO
          title={
            this.state.package_name +
            " | Best Hospital in Bangladesh | United Hospital"
          }
          description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
          pathSlug="/"
          keywords="Department, departments, Cardiac Surgery, Single department"
        />
        <Helmet>
          <meta
            name="description"
            content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
          />

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "http://schema.org",
              "@type": "LocalBusiness",
              name: "United Hospital Limited",
              image:
                "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
              telephone: "10666",
              email: "info@uhlbd.com",
              address: {
                "@type": "PostalAddress",
                streetAddress: "plot 15, Road 71, Gulshan",
                addressLocality: "Dhaka",
                addressRegion: "Dhaka",
                addressCountry: "Bangladesh",
                postalCode: "1212",
              },
              openingHoursSpecification: {
                "@type": "OpeningHoursSpecification",
                opens:
                  "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
              },
              url: "http://www.uhlbd.com/",
              aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
                ratingCount: "756",
              },
              review: {
                "@type": "Review",
                author: {
                  "@type": "Person",
                  name: "abdul kahar",
                },
                datePublished: "2019-02-12",
                reviewRating: {
                  "@type": "Rating",
                  ratingValue: "3.9",
                  bestRating: "5",
                  worstRating: "1",
                },
                reviewBody:
                  "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
              },
            })}
          </script>
          <meta
            name="Subject"
            content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
          />
          <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
          <meta name="Googlebot" content="all" />
          <meta http-equiv="imagetoolbar" content="no" />
          <meta name="robots" content="index, follow" />
          <meta name="copyright" content="Copyright &copy; uhlbd.com" />
          <meta name="owner" content="United Hospital" />
          <meta name="author" content="dcastalia.com" />
          <meta name="Rating" content="General" />
          <meta name="distribution" content="Global" />
          <meta
            name="classification"
            content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
          />
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <meta
            names="apple-mobile-web-app-status-bar-style"
            content="black-translucent"
          />
          <meta
            name="msvalidate.01"
            content="16C4E0B16E39354E550F64BD707F6A97"
          />
        </Helmet>

        <Route component={Header} />
        <div
          className=""
          id="giveMargin"
          style={{ backgroundColor: "#fef3e9" }}
        >
          <section
            className="top-section"
          // style={{ backgroundColor: "rgb(245, 130, 32)" }}
          >
            <img src={banner_img} alt="banner-profile" className="w-100" />
            {/* <div className="headers">
              <h3 className="text-light mt-2 ">{this.state.package_name}</h3>
              <div className="menus mx-5"></div>
            </div> */}
          </section>

          <section className="prof-dr">
            <div className="container">
              <div className="w-100 d-flex justify-content-center align-items-center flex-column py-4">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    // margin: "0 auto",
                    marginBottom: "10px",
                  }}
                >
                  <h3
                    className="text-center"
                    style={{
                      color: "#0C807D",
                      fontSize: "28px",
                      fontWeight: "500",
                    }}
                  >
                    Packages
                  </h3>
                  {/* <img src="/assets/images/department_under.png" alt="" /> */}
                </div>
              </div>
              {/* <h3
                className="text-center pb-5 text-center"
                style={{
                  color: "#0C807D",
                  fontWeight: "700",
                  width: "100%",
                }}
              >
                Packages
              </h3> */}
              <div className="box-of-about pb-4">
                <div className="row">
                  <div
                    className="col-lg-8 col-md-8 mx-2 py-4"
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "5px",
                      // width: "100%",
                      // maxWidth: "600px",
                    }}
                  >
                    {this.state.package_pic ? (
                      <img
                        src={
                          IMAGE_URL + "Packagesimg/" + this.state.package_pic
                        }
                        style={{
                          maxHeight: "300px",
                          objectFit: "cover",
                          objectPosition: "center",
                          borderRadius: "10px",
                        }}
                        alt="banner-profile"
                        className="w-100 img-fluid"
                      />
                    ) : (
                      <img
                        src={banner_img}
                        alt="banner-profile"
                        className="w-100 img-fluid"
                      />
                    )}
                    <div className="text-profile single_package_details_section p-3">
                      <div className="row mb-4 gy-2">
                        <div className="col-2 col-md-4">
                          <strong>Age:</strong> {this.state.package_age}
                        </div>
                        <div className="col-2 col-md-4">
                          <strong>Gender:</strong> {this.state.package_gender}
                        </div>
                        <div className="col-4 col-md-4">
                          <strong>Department:</strong>{" "}
                          {this.state.package_department}
                        </div>
                        <div className="col-3 col-md-4">
                          <strong>Pre Condition:</strong>{" "}
                          {this.state.package_pre_condition === "1"
                            ? "IPD"
                            : "OPD"}
                        </div>
                        <div className="col-3 col-md-4">
                          <strong>IPD Amount:</strong> {this.state.ipd_amount}
                        </div>
                        <div className="col-3 col-md-4">
                          <strong>OPD Amount:</strong> {this.state.opd_amount}
                        </div>
                      </div>
                      <hr className="w-75" />
                      <h2>{this.state.package_name}</h2>
                      <p
                        className="text-chnage"
                        dangerouslySetInnerHTML={{
                          __html: this.state.package_desc,
                        }}
                      ></p>
                    </div>
                  </div>
                  <div
                    className="col-lg-4 col-md-12 d-none d-md-block pt-2"
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "5px",
                      width: "100%",
                      maxWidth: "360px",
                    }}
                  >
                    {/* <div className="text-profile" id="mobile-part">
                    <div id="sidebar-2" className="row">
                      <div className="col-md-12 sidebar-item ">
                        <a
                          className="category-list-link open-cat-list"
                          href="#"
                        >
                          Select Departments
                        </a>
                        <ul
                          className="list-unstyled category-list patients-category-list"
                          id="department-list-sidebar"
                        >
                          {this.state.departments.length > 0
                            ? this.state.departments.map((department) => {
                                var department_name =
                                  department.department_name;
                                var new_department_name =
                                  department_name.replaceAll(" ", "-");
                                return (
                                  <li>
                                    <a
                                      className=""
                                      href={
                                        SITE_URL +
                                        "/departments/" +
                                        department.slug
                                      }
                                    >
                                      {department_name}
                                    </a>
                                  </li>
                                );
                              })
                            : ""}
                        </ul>
                      </div>
                    </div>
                  </div> */}
                    <div
                      className="bookarea mt-3 d-none d-md-block mb-3"
                      style={{ position: "sticky", zIndex: "3333", top: 100 }}
                    >
                      <iframe
                        width="100%"
                        height="315"
                        src={this.state.dynamic_video}
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; muted"
                        allowfullscreen
                      ></iframe>
                      <h5
                        className="text-center p-2 text-light"
                        style={{
                          backgroundColor: "#0C807D",
                          marginTop: "-6px",
                        }}
                      >
                        Call Emergency Line
                        <br />
                        10666
                      </h5>
                      <img
                        src={
                          "https://www.uhlbd.com/resources/images/contact.jpg"
                        }
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Route component={Footer} />
      </div>
    );
  }
}
export default SinglePackage;



// WEBPACK FOOTER //
// ./src/component/frontend/singlepackage.js